import { render } from "./BaseDate.vue?vue&type=template&id=d8ff94b4&scoped=true"
import script from "./BaseDate.vue?vue&type=script&lang=js"
export * from "./BaseDate.vue?vue&type=script&lang=js"

import "./BaseDate.vue?vue&type=style&index=0&id=d8ff94b4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d8ff94b4"]])

export default __exports__